'use client';

import {
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild,
} from '@headlessui/react';
import { Fragment, useContext, useState } from 'react';
import Form from '../pop-up-input-form';
import { createLead } from '@/app/lib/actions';
import Image from 'next/image';
import pdf_icon from '../../../../public/pdf_icon.png';
import { GrClose } from 'react-icons/gr';
import { FaCheckCircle } from 'react-icons/fa';
import { ReportContext } from '@/app/providers/reportProvider';
import { useTranslations } from 'next-intl';

export default function TocPopUp({ isOpen, setIsOpen }) {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const report = useContext(ReportContext);
  const thank_you = useTranslations('thank_you');
  const banner = useTranslations('titlebanner');

  function closeModal() {
    setIsOpen(false);
    setTimeout(setIsSubmitted(false), 3000);
  }

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-20" onClose={() => false}>
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </TransitionChild>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center ">
              <TransitionChild
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <DialogPanel className="w-full max-w-md  transform overflow-hidden rounded-2xl bg-gray-100 p-2 text-center align-middle shadow-xl transition-all">
                  <div className="text-end">
                    <button onClick={closeModal} className="btn border-0">
                      <GrClose size={25} />
                    </button>
                  </div>
                  {isSubmitted ? (
                    <FaCheckCircle
                      size={60}
                      className="mx-auto animate-bounce"
                      style={{ color: '#13c007' }}
                    />
                  ) : (
                    <Image
                      src={pdf_icon}
                      className="mx-auto"
                      height={40}
                      width={35}
                      title="pdf"
                      alt="pdf"
                    />
                  )}
                  {isSubmitted ? (
                    ''
                  ) : (
                    <DialogTitle
                      as="h3"
                      className="text-lg font-semibold leading-6 text-gray-900 uppercase my-3"
                    >
                      {report.keyword} <br /> {banner('title')}(
                      {report.studyperiod})
                    </DialogTitle>
                  )}

                  {isSubmitted ? (
                    <div className="mt-4 w-full mx-auto p-3">
                      <div>
                        <p className="text-center font-semibold text-4xl">
                          {thank_you('p1')}
                        </p>
                        <p className="text-center mt-3">{thank_you('p2')}</p>
                      </div>
                    </div>
                  ) : (
                    <Form
                      formAction={createLead}
                      formType={'Customization'}
                      keyword={report.keyword}
                      CustomName={report.CustomName}
                      reportId={report.newsId}
                      setIsSubmitted={setIsSubmitted}
                    />
                  )}
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
